import React from "react";
import { useNavigate } from "react-router-dom";
import { Inbox, Mail, UploadCloud, ArrowUpRight } from "lucide-react";

const CHANNELS = [
  { key: "forwarding", label: "Forwarding address", icon: Inbox, bar: "bg-rose-400", text: "text-rose-400", path: "/upload" },
  { key: "gmail", label: "Gmail sync", icon: Mail, bar: "bg-primary", text: "text-primary", path: "/upload" },
  { key: "upload", label: "Upload & paste", icon: UploadCloud, bar: "bg-emerald-400", text: "text-emerald-400", path: "/upload" },
];

export const InboundChannels = ({ channels }) => {
  const navigate = useNavigate();
  if (!channels) return null;
  const total = channels.total || 0;
  const pct = (n) => (total ? Math.round((n / total) * 100) : 0);
  const month = new Date().toLocaleDateString("en-GB", { month: "long" });
  return (
    <div className="rounded-xl border border-border bg-card p-5" data-testid="inbound-channels">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div>
          <div className="text-sm font-medium">How invoices arrived in {month}</div>
          <div className="text-xs text-muted-foreground">{total ? `${total} invoice${total === 1 ? "" : "s"} this month` : "No invoices yet this month"}</div>
        </div>
        <button onClick={() => navigate("/upload")} className="text-xs text-primary hover:underline flex items-center gap-0.5" data-testid="inbound-channels-link">
          Manage channels <ArrowUpRight className="h-3 w-3" />
        </button>
      </div>
      <div className="mt-3 flex h-2 w-full overflow-hidden rounded-full bg-muted" data-testid="inbound-channels-bar">
        {CHANNELS.map((c) => channels[c.key] > 0 && (
          <div key={c.key} className={`${c.bar} transition-[width] duration-500`} style={{ width: `${pct(channels[c.key])}%` }} title={`${c.label}: ${channels[c.key]}`} />
        ))}
      </div>
      <div className="mt-3 grid grid-cols-3 gap-3">
        {CHANNELS.map((c) => (
          <div key={c.key} className="flex items-center gap-2.5" data-testid={`inbound-channel-${c.key}`}>
            <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-muted ${c.text}`}><c.icon className="h-4 w-4" /></span>
            <div className="min-w-0">
              <div className="font-mono text-lg font-bold leading-none" data-testid={`inbound-channel-${c.key}-count`}>{channels[c.key]}</div>
              <div className="text-[11px] text-muted-foreground truncate">{c.label} · {pct(channels[c.key])}%</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
